import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { ShiftInfo, ShiftTaskInfo } from '../types';
import { InfoActionService } from '../../../../element-utils/element-actions/info-action/info-action.service';
import { VRGroupService } from '../../vrgroup.service';
import { AppMessageService } from '../../../../shared/app-message/app-message.service';
import { AppMessage } from '../../../../shared/app-message/app-message';
import { _ } from '~shared/utils';
import { MapService } from '~app/shared/map/map.service';

@Component({
  selector: 'qm-vr-workshift-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit, OnChanges {
  @Input()
  shiftInfo: ShiftInfo;
  @Input()
  shiftTaskInfo: ShiftTaskInfo[];
  constructor(
    private vrGroupService: VRGroupService,
    private mapService: MapService,
    private infoActionService: InfoActionService,
    private appMessageService: AppMessageService) { }

  ngOnInit() {
  }
  ngOnChanges(): void {
  }

  async openTrainInfo(event: Event, taskInfo: ShiftTaskInfo): Promise<void> {
    event.preventDefault();
    let feature;
    if (taskInfo.taskType === 'transfer') {
      return;
    }

    try {
      feature = await this.vrGroupService.getTrainMapElement(taskInfo.taskLabel, taskInfo.operatingDate);
    } catch (err) {
      console.error('getTrainMapElement failed: ', err);
    }
    if (feature) {
      this.mapService.changeCurrentFeature(feature);
      this.infoActionService.openDetails(feature.layer, feature, 'personel');
    } else {
      console.warn('No data found for selected train');
      const msgText = _('Train information is not available');
      this.appMessageService.broadcastAlarm(new AppMessage(true, msgText, 'warning', ''));
    }
  }
}
